import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { PlantsDropDown } from "./units-drop-down";

export class PlantsDropDownResponse extends GlobalResponseObject {
        data?: PlantsDropDown[];
        constructor(status: boolean, intlCode: number, internalMessage: string, data?: PlantsDropDown[]){
            super(status,intlCode,internalMessage)
            this.data = data;
        }
}